import React, { Fragment, useState, useEffect } from "react";
import { Col, Container, Row, Card, CardBody, Button, ButtonToolbar, Table } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';

import ProductionOrder from "./components/ProductionOrder";

const RadioPharmacy = ({ history, location }) => {

    useEffect(() => {
    }, []);

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">Radio Farmacia</h3>
                </Col>
            </Row>
            <Card>
                <CardBody>

                    <ProductionOrder />
                    

                </CardBody>
            </Card>
        </Container>
    );
}
export default reduxForm({
    form: 'horizontal_form_radio_pharmacy',
})(RadioPharmacy);